<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import moment from "moment"
import Loader from '@/components/widgets/loader'
import { saveAs } from 'file-saver';
import { apiService } from '@/helpers/api.service';
import { permissionsMap, checkPermission } from '@/utils/utilsPermissions';
import Swal from 'sweetalert2';

export default {
    components: { Layout, PageHeader, Loader },
    data() {
        return {
            statusCode: '',
            code: '',
            fromDate: '',
            toDate: '',
            showModal: false,
            loadingModal: false,
            estimatedTime: '',
            minAmount: '',
            orderDateModal: '',
            hasDiscount: '',
            itemBuy: [
                {Medio_de_Pago: ''}
            ],
            items: [
                { Detalle: '', Cantidad: null, Precio_Unitario: null, Total:null },
                { Detalle: '', Cantidad: null, Precio_Unitario: null, Total:null },
                { Detalle: '', Cantidad: null, Precio_Unitario: null, Total:null },
                { Detalle: '', Cantidad: null, Precio_Unitario: null, Total:null }
            ],
            loading: true,
            storeName: '',
            textError: '',
            orderModal: {},
            showPagination: true,
            PaymentMethodType: {
                CREDIT_CARD: 'credit_card',
                DEBIT_CARD: 'debit_card',
                TICKET: 'ticket',
                BANK_TRANSFER: 'bank_transfer',
                ACCOUNT_MONEY: 'account_money'
            },
            OrderStatus: {
                new: 'Nueva',
                preparing: 'En Preparación',
                prepared: 'Preparada',
                rejected: 'Rechazada',
                canceled: 'Cancelada',
                picked: 'Entregado a delivery',
                in_travel: 'En Viaje',
                arrived_customer: 'En delivery point',
                delivered: 'Entregada',
                lost: 'Perdida',
                PENDING: 'Pendiente',
                PROCESSED: 'Procesado',
                COMPLETED: 'Completado',
            },
            orders: [],
            tableHeaders: ['Fecha', 'N° de pedido', 'Contenido', 'Aclaración', 'Monto', 'Descuento', 'Estado'],
            tableData: [],
            currentPage: 1,
            itemsPerPage: 10,
            meta_data: null
        };
    },
    mounted() {
        let user = JSON.parse(localStorage.getItem('user')).data.user
        const store = localStorage.getItem('store') != "undefined" ? JSON.parse(localStorage.getItem('store')) : {"name": user.name, "isOpen": false}
        this.storeName = store.name
        this.getHistory()
        this.canDownloadHistory()
    },
    watch: {
        currentPage() {
            this.getHistory({}, this.currentPage, this.itemsPerPage)
        }
    },
    methods: {
        canDownloadHistory() {
            return checkPermission(permissionsMap.DOWNLOAD_STORE_HISTORY, this.$store.state.permissions);
        },
        handleImageClick(order) {
            this.items = [];
            this.itemBuy = [];
            this.loadingModal = true
            
            apiService.getOrderById(order._id)
            .then((res) => {
                if (res) {
                    this.orderModal = res;
                    this.showModal = true;
                    this.estimatedTime = res.estimatedTime ? res.estimatedTime + 'min' : '-'
                    this.orderDateModal = moment(res?.createdAt).format('DD/MM/YYYY') ?? '-'

                    this.itemBuy.push({
                    Medio_De_Pago:  res?.payment?.paymentMethod?.type ? this.returnNameMethod() : '-' ,
                })

                res.dishes.forEach(dish => {
                    this.items.push({
                        Detalle: dish.name ?? '',
                        Cantidad: dish.quantity ?? null,
                        Precio_Unitario: dish?.unitPrice ? this.formatPrice(dish?.unitPrice) : null,
                        Total: dish.price ?  this.formatPrice(dish?.price * dish?.quantity) : null,
                    });

                });


                this.addAddonAndPersonalize(res)


                this.addSubtotalRow(res);


                this.addCupon(res)



                this.addtotalRow(res);
            } else {
                this.orderModal = {}
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'No se pudo obtener la orden',
                })
            }
        }) .catch(() => {
            this.orderModal = {}
        }) .finally(() => {
            this.loadingModal = false
        })


    },
    addAddonAndPersonalize(res) {
        res.dishes.forEach((dish) => {
            this.items.push({
                Detalle: dish.name ?? '',
                Cantidad: dish.quantity ?? null,
                Precio_Unitario: dish?.unitPrice ? this.formatPrice(dish?.unitPrice) : null,
                Total: dish.price ? this.formatPrice(dish?.price * dish?.quantity) : null,
            });

            if (dish.personalize && dish.personalize.length > 0) {
            let hasOptions = false;
            dish.personalize.forEach((personalization) => {
                if (personalization.options && personalization.options.length > 0) {
                    hasOptions = true;
                    personalization.options.forEach((option) => {
                        this.items.push({
                            Detalle: option?.name ? `Sabor: ${option.name}` : 'No tiene sabor',
                            Cantidad: null,
                            Precio_Unitario: null,
                            Total: null,
                        });
                    });
                }
            });

            if (!hasOptions) {
                this.items.push({
                    Detalle: 'No hay sabores',
                    Cantidad: null,
                    Precio_Unitario: null,
                    Total: null,
                });
            }
        } else {
            this.items.push({
                Detalle: 'No hay sabores',
                Cantidad: null,
                Precio_Unitario: null,
                Total: null,
            });
        }

        // ADDONS
        if (dish.addon && dish.addon.length > 0) {
            let hasAddonOptions = false;
            dish.addon.forEach((addon) => {
                if (addon.options && addon.options.length > 0) {
                    hasAddonOptions = true;
                    addon.options.forEach((option) => {
                        this.items.push({
                            Detalle: option?.name ? `Extras: ${option.name}` : 'No lleva extras',
                            Cantidad: 1,
                            Precio_Unitario: option.price ? this.formatPrice(option.price) : null,
                            Total: option.price ? this.formatPrice(option.price) : null,
                        });
                    });
                }
            });

            if (!hasAddonOptions) {
                this.items.push({
                    Detalle: 'No hay extras',
                    Cantidad: null,
                    Precio_Unitario: null,
                    Total: null,
                });
            }
        } else {
            this.items.push({
                Detalle: 'No hay extras',
                Cantidad: null,
                Precio_Unitario: null,
                Total: null,
            });
        }
        });
    },


    addtotalRow(order) {
        this.items.push({
            Detalle: 'Total',
            Cantidad: null,
            Precio_Unitario: null,
            Total: order?.total ? this.formatPrice(order?.total) : "-",
        });
    },
    addSubtotalRow(order) {
        this.items.push({
            Detalle: 'Subtotal',
            Cantidad: null,
            Precio_Unitario: null,
            Total: order?.subtotal ? this.formatPrice(order?.subtotal) : null,
        });
    },

    addCupon(order) {
        this.items.push({
            Detalle: 'Descuento',
            Cantidad: null,
            Precio_Unitario: null,
            Total: order?.order_coupon ? this.formatCupon(order?.order_coupon) : '-',
        });
    },


    formatCupon(cupon) {
        if (cupon.discount_type === "Fixed_Price") return this.formatPrice(cupon.amount);
        return `${cupon.amount}%`;
    },

    formatPrice(number) {
    const options = {
        style: 'currency',
        currency: 'ARS',
        minimumFractionDigits: 0,
        maximumFractionDigits: 1,
    };
    const hasDecimal = number % 1 !== 0;
    if (hasDecimal) {
        options.minimumFractionDigits = 1;
    }
    return number.toLocaleString('es-AR', options);
    },

        closeModal() {
            this.showModal = false;
        },
        adjustDatesToISO8601(from, to) {
            let fromISO = null;
            let toISO = null;

            if (from) {
                fromISO = `${from}T00:00:00Z`; 
            }
            if (to) {
                toISO = `${to}T23:59:59Z`;
            }

            return { fromISO, toISO };
        },
        async handleSearch() {
            const filters = {};

            if (this.statusCode && this.statusCode !== 'todos') {
                filters.statusCode = this.statusCode;
            }
            if (this.code) {
                filters.code = this.code;
            }
            if (this.fromDate) {
                const { fromISO } = this.adjustDatesToISO8601(this.fromDate, '');
                if (fromISO) filters.fromDate = fromISO;
            }

            if (this.toDate) {
                const { toISO } = this.adjustDatesToISO8601('', this.toDate);
                if (toISO) filters.toDate = toISO;
            }
            if (this.minAmount) {
                filters.minAmount = this.minAmount;
            }
            if (this.hasDiscount) {
                filters.hasDiscount = this.hasDiscount;
            }

            if (this.fromDate <= this.toDate) {
                await this.getHistory(filters, this.currentPage, this.itemsPerPage);
                this.textError = "";
            } else {
                this.textError = "La fecha de inicio debe ser menor a la fecha de fin";
            }

        },

        async handleReset() {
            this.statusCode = '';
            this.code = '';
            this.fromDate = '';
            this.toDate = '';
            this.minAmount = '';
            this.hasDiscount = '';

            await this.getHistory({});
        },
        async getHistory(params = {}, page = this.currentPage, limit = this.itemsPerPage) {
            this.loading = true
            await apiService.getHistory(params, page, limit)
                .then((res) => {
                    if (res.orders && res.orders.length > 0) {
                        this.meta_data = res.meta_data;
                        this.orders = res.orders.map(e => {
                            const formattedDate = moment(e.createdAt).format('DD/MM/YY - HH:mm [hs]');
                            const formattedStatus = this.OrderStatus[e?.status?.code] || '-';
                            return { ...e, createdAt: formattedDate, status: formattedStatus };
                        });
                        this.showPagination = true;
                    } else {
                        this.orders = [];
                        this.showPagination = false;
                    }
                }).catch(() => {
                    this.orders = [];
                    this.showPagination = false;
                }).finally(() => {
                    this.loading = false
                })
        },

        async downloadFile (fileFormat) {
            let fromDate = null;
            let toDate = null;

            if(this.fromDate){
                 fromDate = new Date(this.fromDate).toISOString();
            }
            
            if(this.toDate){
                toDate = new Date(this.toDate);
                toDate.setUTCHours(23, 59, 59, 999);
                toDate = toDate.toISOString();
            }

            const filters = {
                fileFormat: fileFormat,
                statusCode: this.statusCode,
                code: this.code,
                fromDate: fromDate,
                toDate: toDate,
                minAmount: this.minAmount,
                hasCoupon: this.hasCoupon
            };
            
            Object.keys(filters).forEach(key => {
                if (filters[key] === '' || filters[key] === null || filters[key] === undefined) {
                    delete filters[key];
                }
            });
            
            await apiService.downloadHistory(filters).then(async res => {
                if(res){
                    const buffer = res.data
                    saveAs(buffer, `${this.storeName}.${fileFormat}`)
                } else {
                    console.error('Error downloading file');
                    await Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Ocurrio un error al descargar el archivo.",
                        showConfirmButton: false,
                        timer: 4500
                    })
                }
            }).catch(err => {
                console.error('Error downloading file:', err);
                Swal.fire({
                    position: "center",
                    icon: "error",
                    title: "Ocurrio un error al descargar el archivo.",
                    showConfirmButton: false,
                    timer: 4500
                })
            })
        },

        changePage(page) {
            const totalPages = Math.ceil(this.meta_data?.total_documents / this.itemsPerPage);
            if (page === '...' || page < 1 || page > totalPages) return;
            this.currentPage = page;
        },
        formatDiscount(orderDiscount){
        if (!orderDiscount || !orderDiscount.amount) return null;

        return orderDiscount.type === 'Percentage' 
            ? `${orderDiscount.label}`
            : this.formatPrice(orderDiscount.amount)
        },
        
        returnNameMethod() {
        const method = this.orderModal?.payment?.paymentMethod?.type

        switch (method) {
            case  this.PaymentMethodType.CREDIT_CARD:
                return 'Tarjeta de Crédito';
              case  this.PaymentMethodType.DEBIT_CARD:
                return 'Tarjeta de Débito';
              case  this.PaymentMethodType.TICKET:
                return 'Ticket';
              case  this.PaymentMethodType.BANK_TRANSFER:
                return 'Transferencia Bancaria';
              case  this.PaymentMethodType.ACCOUNT_MONEY:
                return 'Dinero en Cuenta';
              default:
                return '-';
        }
    },

        pagesToShow() {
            const totalPages = Math.ceil(this.meta_data?.total_documents / this.itemsPerPage);
            if (totalPages <= 5) {
                return Array.from({ length: totalPages }, (_, i) => i + 1);
            }
            const pages = new Set([1, totalPages]);
            if (this.currentPage <= 2) {
                [2, 3, 4].forEach(page => pages.add(page));
            } else if (this.currentPage >= totalPages - 1) {
                [totalPages - 3, totalPages - 2, totalPages - 1].forEach(page => pages.add(page));
            } else {
                [this.currentPage - 1, this.currentPage, this.currentPage + 1].forEach(page => pages.add(page));
            }
            return Array.from(pages).sort((a, b) => a - b);
        },
    }
}
</script>

<template>
    <Layout>
        <PageHeader />
        <Loader v-show="loading"></Loader>
        <div class="history card-welly" v-show="!loading">
            <div class="responsive-container">
                <div class="input-group">
                    <select class="form-control inputGlobal" v-model="statusCode">
                    <option value="" selected>Todos</option>
                    <option v-for="(status, key) in OrderStatus" :key="key" :value="key">
                        {{ status }}
                    </option>
                    </select>

                    <input type="number" min="0" class="form-control inputGlobal" placeholder="N° de pedido" v-model="code">
                    <input type="date" class="form-control inputGlobal" placeholder="Desde" v-model="fromDate">
                    <input type="date" class="form-control inputGlobal" placeholder="Hasta" v-model="toDate">
                    <input type="number" min="0" class="form-control inputGlobal" placeholder="Monto" v-model="minAmount">

                    <select class="form-control inputGlobal" v-model="hasDiscount">
                    <option value="" selected>Descuento</option>
                    <option value="true">Sí</option>
                    <option value="false">No</option>
                    </select>
                </div>

                <div class="button-group">
                    <b-button type="button" variant="success" @click="handleSearch" class="btn-success">Buscar</b-button>
                    <b-button type="button" class="btn-cancel" variant="outline-danger" @click="handleReset">Limpiar</b-button>
                </div>
            </div>

        
        <p class="text-danger" v-if="textError">{{ textError }}</p>
            <div class="history-table">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="history-table-space"></th>
                            <th>Fecha</th>
                            <th>N° de pedido</th>
                            <th>Estado</th>
                            <th>Cupón</th>
                            <th>Descuento</th>
                            <th>Subtotal</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody class="table-body" v-for="(order, orderIndex) in orders" :key="`order-${orderIndex}`">
                        <tr v-show="order.status"  :class="orderIndex % 2 === 0 ? 'even-row' : 'odd-row'">
                            <td :rowspan="order.dishes.length" class="history-table-space"></td>
                            <td :rowspan="order.dishes.length" class="order-row order-date">{{ order.createdAt }}</td>
                            <td :rowspan="order.dishes.length" class="order-row"><b>#{{ order.code }}</b></td>
                            <td :rowspan="order.dishes.length" class="order-row">{{ order.status }}</td>
                            <td :class="order.order_coupon ? order.order_coupon.class : ''" class="order-row">
                                {{ order?.order_coupon?.name ? 'Sí' : 'No' }}
                            </td>
                            <td :rowspan="order.dishes.length" class="order-row">{{  formatDiscount(order?.dishes[0].discount)  }} </td>
                            <td :rowspan="order.length" class="order-row">{{  order?.subtotal ? formatPrice(order?.subtotal) : '-'  }}</td>
                            <td class="order-row">
                                <img
                                    src="@/assets/images/arrow-down.svg"
                                    alt
                                    class="rounded-circle"
                                    height="20"
                                    @click="handleImageClick(order)"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="orders.length === 0" class="no-orders">Todavía no se han registrado pedidos.</div>


                <div v-if="showPagination" class="pagination">
                    <button @click="changePage(currentPage - 1)" :disabled="currentPage === 1">&lt;</button>
                    <button 
                        v-for="page in pagesToShow()" 
                        :key="page" 
                        @click="changePage(page)" 
                        :class="{ active: currentPage === page }"
                        :disabled="page === '...'">
                        {{ page }}
                    </button>
                    <button @click="changePage(currentPage + 1)" :disabled="currentPage === Math.ceil(orders.length / itemsPerPage)">&gt;</button>
                </div>
            </div>

            <br />

            <div class="row download-btn-container" :style="{ 'display': canDownloadHistory() ? 'flex' : 'none' }">
                <div class="right">
                    <b-button href="#" type="submit" variant="success" v-on:click="downloadFile('csv')" class="btn-success">
                        <img src="@/assets/images/stats.png" />
                        Descargar historial en CSV
                    </b-button>
                    <b-button href="#" type="submit" variant="success" v-on:click="downloadFile('xlsx')" class="btn-success">
                        <img src="@/assets/images/stats.png" />
                        Descargar historial en Excel
                    </b-button>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <b-modal v-model="showModal" title="" size="lg" hide-footer="true">

          <div class="modal-item">
            <label class="label-row">Información General</label>
            <p><strong>Estado:</strong> {{ OrderStatus[orderModal?.status?.code] ?? '-' }}</p>
            <p><strong>Fecha:</strong> {{ this.orderDateModal }}</p>
            <p><strong>Tiempo de preparación:</strong> {{ orderModal?.prepTime ?? '-' }}</p>
            <!-- <p><strong>Tiempo de entrega:</strong> {{ this.estimatedTime }}</p> -->
        </div>

            <label class="label-row">Detalles de los Productos</label>
            <b-table striped hover :items="items"></b-table>

            <b-table striped hover :items="itemBuy"></b-table>

        </b-modal>
    </Layout>
</template>

<style lang="scss" scoped>
@import "@/design/settings";
@import '@/design/views/history';
</style>